module.exports = __webpack_public_path__ + "img/new-radio.52a45758.svg";